export default __webpack_public_path__ + "static/media/47_mobile.c79dc552.jpg";